// src/components/ServicesSection.js
import React from "react";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaPaintBrush,
  FaCloud,
  FaDatabase,
  FaHandsHelping,
} from "react-icons/fa";
import ServicesIllustration from "../assets/mobile-development.svg"; // ✅ Confirm correct path

const iconClass =
  "text-[#4C47DC] text-xl md:text-2xl transition-transform duration-300 group-hover:scale-110";

const services = [
  {
    title: "Web Applications",
    description:
      "Custom web solutions using modern stacks for scale, security, and performance.",
    icon: <FaLaptopCode className={iconClass} />,
  },
  {
    title: "Mobile Applications",
    description:
      "Cross-platform and native apps tailored for usability and growth.",
    icon: <FaMobileAlt className={iconClass} />,
  },
  {
    title: "UI/UX Design",
    description:
      "Intuitive, elegant, and responsive interfaces for all devices.",
    icon: <FaPaintBrush className={iconClass} />,
  },
  {
    title: "Cloud & DevOps",
    description:
      "Cloud-native infrastructure, CI/CD pipelines, and automation.",
    icon: <FaCloud className={iconClass} />,
  },
  {
    title: "Backend Systems",
    description:
      "Robust APIs and backend architectures for seamless data flow.",
    icon: <FaDatabase className={iconClass} />,
  },
  {
    title: "Consulting & Support",
    description:
      "Strategic guidance and long-term tech support for your journey.",
    icon: <FaHandsHelping className={iconClass} />,
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="bg-gray-50 py-20">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        {/* Left: Services List */}
        <div>
          <h2 className="text-3xl font-bold text-[#4C47DC] mb-8">
            Our Services
          </h2>
          <ul className="space-y-6">
            {services.map((service, index) => (
              <li
                key={index}
                className="flex items-start space-x-4 group transition-all"
              >
                <div className="flex-shrink-0 mt-1">{service.icon}</div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {service.description}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Right: Illustration */}
        <div className="hidden md:block">
          <img
            src={ServicesIllustration}
            alt="Our Services"
            className="w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
